import ApplicationInstance from '@ember/application/instance';
import config from 'scaleflow/config/environment';

export function initialize(application: ApplicationInstance) {
  const appConfig = application.resolveRegistration(
    'config:environment',
  ) as typeof config;

  const challengeURL = appConfig.CHALLENGE_URL;
  if (!challengeURL) return;
  window.awsWafCookieDomainList = ['.scaleflow.com'];
  const script = document.createElement('script');
  script.src = `${challengeURL}`;
  script.defer = true;
  document.head.appendChild(script);
}

export default {
  initialize,
};
